export {CarouselModule} from './carousel.module';
export * from './carousel-item.directive';
export * from './carousel.component';
export * from './carousel.providers';
